/* Feelair: Cap "testpakke" product at 1 per cart.
   - Intercepts /cart/add, /cart/change, /cart/update via fetch + XHR + form submit
   - After every cart write, re-reads /cart.js and forces qty back to 1 if it slipped through
   - If somehow >1 testpakke remains in cart, swaps the cart-drawer checkout button text to
     "Max 1 Testpakke per kunde" and disables it. */
(function () {
  var TESTPAKKE_HANDLE = 'testpakke';
  var TESTPAKKE_VARIANT_ID = '56234335437187';
  var TESTPAKKE_PRODUCT_ID = '15336347926915';
  var MAX_QTY = 1;
  var OVERFLOW_LABEL = 'Max 1 Testpakke per kunde';

  var originalFetch = window.fetch.bind(window);

  function injectStyles() {
    if (document.getElementById('testpakke-qty-limit-styles')) return;
    var style = document.createElement('style');
    style.id = 'testpakke-qty-limit-styles';
    style.textContent = [
      '.cart__checkout--disabled-tp {',
      '  opacity: 0.5 !important;',
      '  cursor: not-allowed !important;',
      '  pointer-events: none !important;',
      '  filter: grayscale(0.6);',
      '}',
      /* Testpakke: hide the plus button (keep it in DOM so theme.js QtySelector init doesn't crash).
         Trim only the wrapper's max-width and the input's right padding to collapse the empty plus slot.
         Don't touch the input width or wrapper display — that's what minus's absolute hit-area relies on. */
      '.cart__item--testpakke .js-qty__adjust--plus { visibility: hidden !important; pointer-events: none !important; width: 0 !important; padding: 0 !important; }',
      '.cart__item--testpakke .js-qty__wrapper { max-width: 56px !important; }',
      '.cart__item--testpakke .js-qty__num { padding-right: 6px !important; }'
    ].join('\n');
    (document.head || document.documentElement).appendChild(style);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStyles);
  } else {
    injectStyles();
  }

  function isTestpakkeId(id) {
    if (id == null) return false;
    var s = String(id);
    if (s === TESTPAKKE_VARIANT_ID) return true;
    // Cart line keys are "<variant_id>:<properties_hash>"
    if (s.indexOf(TESTPAKKE_VARIANT_ID + ':') === 0) return true;
    return false;
  }

  function isTestpakkeItem(item) {
    if (!item) return false;
    if (isTestpakkeId(item.id) || isTestpakkeId(item.variant_id)) return true;
    if (item.product_id != null && String(item.product_id) === TESTPAKKE_PRODUCT_ID) return true;
    var handle = item.handle || item.product_handle || (item.product && item.product.handle);
    return handle === TESTPAKKE_HANDLE;
  }

  function isCartWriteUrl(url) {
    if (!url) return false;
    return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function payloadHasTestpakkeAdd(body) {
    if (!body) return false;
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return isTestpakkeId(body.get('id') || body.get('variant_id'));
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return isTestpakkeId(body.get('id') || body.get('variant_id'));
      }
      if (typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed && isTestpakkeId(parsed.id)) return true;
          if (parsed && Array.isArray(parsed.items)) {
            return parsed.items.some(function (it) { return isTestpakkeId(it.id); });
          }
        } catch (e) {
          if (body.indexOf('=') !== -1) {
            try {
              var p = new URLSearchParams(body);
              return isTestpakkeId(p.get('id') || p.get('variant_id'));
            } catch (e2) { /* noop */ }
          }
        }
      }
    } catch (e) { /* noop */ }
    return false;
  }

  function capPayload(body) {
    if (!body) return body;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var idVal = body.get('id') || body.get('variant_id');
      if (isTestpakkeId(idVal)) {
        var q = parseInt(body.get('quantity') || '1', 10);
        if (q > MAX_QTY) body.set('quantity', String(MAX_QTY));
      }
      return body;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var idVal2 = body.get('id') || body.get('variant_id');
      if (isTestpakkeId(idVal2)) {
        var q2 = parseInt(body.get('quantity') || '1', 10);
        if (q2 > MAX_QTY) body.set('quantity', String(MAX_QTY));
      }
      return body;
    }

    if (typeof body === 'string') {
      try {
        var parsed = JSON.parse(body);
        var modified = false;

        if (parsed && parsed.id != null && isTestpakkeId(parsed.id)) {
          if (parsed.quantity != null && parseInt(parsed.quantity, 10) > MAX_QTY) {
            parsed.quantity = MAX_QTY;
            modified = true;
          }
        }

        if (parsed && Array.isArray(parsed.items)) {
          parsed.items.forEach(function (it) {
            if (isTestpakkeId(it.id) && it.quantity != null && parseInt(it.quantity, 10) > MAX_QTY) {
              it.quantity = MAX_QTY;
              modified = true;
            }
          });
        }

        if (parsed && parsed.updates && typeof parsed.updates === 'object' && !Array.isArray(parsed.updates)) {
          Object.keys(parsed.updates).forEach(function (k) {
            if (isTestpakkeId(k) && parseInt(parsed.updates[k], 10) > MAX_QTY) {
              parsed.updates[k] = MAX_QTY;
              modified = true;
            }
          });
        }

        return modified ? JSON.stringify(parsed) : body;
      } catch (e) {
        if (body.indexOf('=') !== -1) {
          try {
            var params = new URLSearchParams(body);
            var changed = false;
            var idVal3 = params.get('id') || params.get('variant_id');
            if (isTestpakkeId(idVal3)) {
              var q3 = parseInt(params.get('quantity') || '1', 10);
              if (q3 > MAX_QTY) {
                params.set('quantity', String(MAX_QTY));
                changed = true;
              }
            }
            return changed ? params.toString() : body;
          } catch (e2) { /* noop */ }
        }
      }
    }

    return body;
  }

  function fakeAddResponseForBlockedTestpakke() {
    // Return a stub /cart/add.js-shaped JSON so the calling code (theme.js) doesn't break.
    var stub = {
      id: Number(TESTPAKKE_VARIANT_ID),
      variant_id: Number(TESTPAKKE_VARIANT_ID),
      product_id: Number(TESTPAKKE_PRODUCT_ID),
      handle: TESTPAKKE_HANDLE,
      quantity: MAX_QTY,
      title: 'Feelair Testpakke',
      price: 0,
      line_price: 0,
      original_price: 0,
      original_line_price: 0,
      sku: 'testpakke',
      __testpakke_blocked: true
    };
    return new Response(JSON.stringify(stub), {
      status: 200,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}

    if (init && init.body && isCartAddUrl(url) && payloadHasTestpakkeAdd(init.body)) {
      // Async-check: only let testpakke add through if cart doesn't already have one at max.
      var args = arguments;
      return originalFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var existing = (cart.items || []).find(function (i) { return isTestpakkeItem(i); });
          if (existing && existing.quantity >= MAX_QTY) {
            // Already at max — block the add.
            try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
            return fakeAddResponseForBlockedTestpakke();
          }
          // Cap the qty in the body and proceed.
          try { init.body = capPayload(init.body); } catch (e) {}
          return originalFetch.apply(window, args).then(function (response) {
            try { if (isCartWriteUrl(response.url || url)) enforceTestpakkeCap(); } catch (e) {}
            return response;
          });
        })
        .catch(function () {
          try { init.body = capPayload(init.body); } catch (e) {}
          return originalFetch.apply(window, args);
        });
    }

    try {
      if (init && init.body && isCartWriteUrl(url)) {
        init.body = capPayload(init.body);
      }
    } catch (e) { /* noop */ }

    var promise = originalFetch.apply(this, arguments);
    return promise.then(function (response) {
      try {
        var rurl = response && response.url ? response.url : '';
        if (isCartWriteUrl(rurl)) {
          enforceTestpakkeCap();
        }
      } catch (e) { /* noop */ }
      return response;
    });
  };

  /* Click hijacker for Shopify cart permalinks like /cart/<variant_id>:<qty>
     Server processes these and redirects to /checkout, bypassing all client JS.
     Catch the click before navigation, then check the cart and route accordingly. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var anchor = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!anchor) return;
    var href = anchor.getAttribute('href') || '';
    if (!href) return;
    var match = href.match(/\/cart\/([0-9]+)(?::[0-9]+)?(?:\?|$|#)/);
    if (!match) return;
    if (match[1] !== TESTPAKKE_VARIANT_ID) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    originalFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = (cart.items || []).find(function (i) { return isTestpakkeItem(i); });
        if (existing && existing.quantity >= MAX_QTY) {
          window.location.href = '/checkout';
          return;
        }
        return originalFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: TESTPAKKE_VARIANT_ID, quantity: MAX_QTY })
        }).then(function () {
          window.location.href = '/checkout';
        });
      })
      .catch(function () {
        window.location.href = '/checkout';
      });
  }, true);

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__tpUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this.__tpUrl && isCartWriteUrl(this.__tpUrl) && body) {
        body = capPayload(body);
      }
    } catch (e) { /* noop */ }
    var self = this;
    this.addEventListener('load', function () {
      try {
        if (self.__tpUrl && isCartWriteUrl(self.__tpUrl)) {
          enforceTestpakkeCap();
        }
      } catch (e) { /* noop */ }
    });
    return xhrSend.call(this, body);
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (idInput && isTestpakkeId(idInput.value) && qtyInput) {
      var q = parseInt(qtyInput.value, 10);
      if (q > MAX_QTY) qtyInput.value = MAX_QTY;
    }
  }, true);

  var lastKnownOverflow = false;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.matches !== 'function') return;
    if (form.id !== 'CartDrawerForm' && !form.matches('form[action$="/cart"], form[action$="/cart/"]')) return;
    var submitter = e.submitter || form.querySelector('button[name="checkout"]:focus, [type="submit"][name="checkout"]');
    if (!submitter || submitter.name !== 'checkout') return;
    if (!lastKnownOverflow) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    updateCheckoutButton(true);
    enforceTestpakkeCap();
  }, true);

  var enforcing = false;
  function enforceTestpakkeCap() {
    if (enforcing) return;
    enforcing = true;
    originalFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var overflow = (cart.items || []).find(function (i) { return isTestpakkeItem(i) && i.quantity > MAX_QTY; });
        lastKnownOverflow = !!overflow;
        if (!overflow) {
          updateCheckoutButton(false);
          return null;
        }
        updateCheckoutButton(true);
        return originalFetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: overflow.key, quantity: MAX_QTY })
        })
          .then(function (r) { return r.json(); })
          .then(function (updated) {
            var stillOver = (updated.items || []).find(function (i) { return isTestpakkeItem(i) && i.quantity > MAX_QTY; });
            lastKnownOverflow = !!stillOver;
            updateCheckoutButton(!!stillOver);
            if (!stillOver) {
              try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
              try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
            }
          });
      })
      .catch(function () { /* noop */ })
      .then(function () { enforcing = false; });
  }

  function updateCheckoutButton(overflow) {
    var buttons = document.querySelectorAll('button[name="checkout"], .cart__checkout');
    buttons.forEach(function (btn) {
      if (!btn.dataset.tpOriginalText) {
        btn.dataset.tpOriginalText = btn.innerHTML.trim();
      }
      if (overflow) {
        btn.innerHTML = OVERFLOW_LABEL;
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('cart__checkout--disabled-tp');
      } else {
        if (btn.classList.contains('cart__checkout--disabled-tp')) {
          btn.innerHTML = btn.dataset.tpOriginalText;
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('cart__checkout--disabled-tp');
        }
      }
    });
  }

  function initialCheck() {
    originalFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var overflow = (cart.items || []).find(function (i) { return isTestpakkeItem(i) && i.quantity > MAX_QTY; });
        if (!overflow) return;
        originalFetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: overflow.key, quantity: MAX_QTY })
        })
          .then(function (r) { return r.json(); })
          .then(function (updated) {
            var stillOver = (updated.items || []).find(function (i) { return isTestpakkeItem(i) && i.quantity > MAX_QTY; });
            updateCheckoutButton(!!stillOver);
            if (!stillOver) {
              try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
            }
          });
      })
      .catch(function () { /* noop */ });
  }

  document.addEventListener('cart:updated', function () {
    setTimeout(function () {
      originalFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var stillOver = (cart.items || []).find(function (i) { return isTestpakkeItem(i) && i.quantity > MAX_QTY; });
          updateCheckoutButton(!!stillOver);
        })
        .catch(function () { /* noop */ });
    }, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialCheck);
  } else {
    initialCheck();
  }
})();
